import React, { useCallback, useRef, useState } from "react"
import { EnumFasesSacola } from "../../../cardapio-sacola";
import { Box, Slide } from "@material-ui/core";
import { useNotificacoes } from "components";
import { TipoPagamento } from "./components/tipo-pagamento/tipo-pagamento";
import { InformarCartao } from "./components/informar-cartao/informar-cartao";
import { CardapioDadosProps } from "modulos/cardapio/containers/cardapio/cardapio-header/cardapio-header-props";
import { SelecionarFormaPagamento } from "./components/selecionar-forma-pagamento/selecionar-forma-pagamento";
import { usePedidos } from "services/providers/pedidos-provider";

export interface FormasPagamentoProps {
    faseSacola: EnumFasesSacola
    fecharSacola: () => void
    empresaId: string
    cardapioDados: CardapioDadosProps | undefined
    mesaId: string
    onClickProximaFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    onClickVoltarFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    fasesPagamento: EnumFasePagamento
    setFasesPagamento: (fase: EnumFasePagamento) => void
    voltarParaFaseFinalizarPedido: React.MutableRefObject<boolean>
}

export enum TpFormaPagamentoEnum {
    Entrega,
    PIX,
    Cartao
}

export enum EnumFalhaFormaPag {
    Nenhuma,
    Pix,
    Entrega
}

export enum EnumFasePagamento {
    SelecionarTipoPagamento,
    SelecionarFormaPagamento,
    InformarCartao
}

export const FormasPagamento = ({
    faseSacola,
    fecharSacola,
    empresaId,
    cardapioDados,
    mesaId,
    onClickProximaFase,
    onClickVoltarFase,
    fasesPagamento,
    setFasesPagamento,
    voltarParaFaseFinalizarPedido
}: FormasPagamentoProps) => {

    const faseFormas = faseSacola === EnumFasesSacola.FormaPagamento

    const { showSuccessMessage } = useNotificacoes()
    const [falha, setFalha] = useState<boolean>(false)
    const [msgErro, setMsgErro] = useState<string>('')
    const nextOrBack = useRef<0 | 1>(1)

    const {
        carregandoRegistrarPix,
        handleRegistroPix,
        cancelarPedido,
        setTransacao
    } = usePedidos()

    const proximo = useCallback((fase: EnumFasesSacola) => {
        onClickProximaFase(nextOrBack, fase)
    }, [onClickProximaFase])

    const voltar = useCallback(() => {
        onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
    }, [onClickVoltarFase])

    const onClickVoltarTipoPagamento = useCallback(() => {
        setFasesPagamento(EnumFasePagamento.SelecionarTipoPagamento)
    }, [setFasesPagamento])

    const clickPix = useCallback(async () => {
        try {
            setMsgErro('')
            setFalha(false)
            await handleRegistroPix()
            proximo(EnumFasesSacola.PagamentoPix)
        } catch (err: any) {
            setMsgErro(err.message)
            setFalha(true)
        }
    }, [handleRegistroPix, proximo])

    const clickCredito = useCallback(() => {
        try {
            setMsgErro('')
            setFalha(false)
            setFasesPagamento(EnumFasePagamento.InformarCartao)
        } catch (err: any) {
            setMsgErro(err.message)
            setFalha(true)
        }
    }, [setFasesPagamento])

    const handleCancelarPedido = useCallback(() => {
        cancelarPedido()
        showSuccessMessage('Pedido cancelado!')
        fecharSacola()
    }, [cancelarPedido, fecharSacola, showSuccessMessage])

    const onClickFaseConfirmacao = useCallback(() => {
        proximo(EnumFasesSacola.ConfirmarInformacoes)
    }, [proximo])

    const clickFinalizar = () => {
        proximo(EnumFasesSacola.FazendoPedido)
    }

    const onClickVoltar = useCallback(() => {
        setFasesPagamento(EnumFasePagamento.SelecionarTipoPagamento)
    }, [setFasesPagamento])

    const onClickPagarDepois = useCallback(() => {
        setTransacao(undefined)
        onClickProximaFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
    }, [onClickProximaFase, setTransacao])

    return (
        <Slide direction={nextOrBack.current === 1 ? "left" : 'right'} mountOnEnter unmountOnExit in={faseFormas}>
            <Box height="100%">
                {fasesPagamento === EnumFasePagamento.SelecionarTipoPagamento && (
                    <TipoPagamento {...{
                        carregandoRegistrarPix,
                        clickCredito,
                        clickFinalizar,
                        clickPix,
                        cardapioDados,
                        empresaId,
                        falha,
                        handleCancelarPedido,
                        mesaId,
                        msgErro,
                        voltar,
                        onClickPagarDepois,
                        onClickTipoPagamento: () => setFasesPagamento(EnumFasePagamento.SelecionarFormaPagamento),
                    }} />
                )}
                {fasesPagamento === EnumFasePagamento.SelecionarFormaPagamento && (
                    <SelecionarFormaPagamento
                        onClickVoltar={onClickVoltarTipoPagamento}
                        onClickFaseConfirmacao={onClickFaseConfirmacao}
                    />
                )}
                {fasesPagamento === EnumFasePagamento.InformarCartao && (
                    <InformarCartao
                        clickFinalizar={clickFinalizar}
                        onClickVoltar={onClickVoltar}
                    />
                )}
            </Box>
        </Slide>
    )
}